import { NgIf } from '@angular/common';
import { Directive, OnInit, inject } from '@angular/core';
import { PwaIntegrationService } from '@df/module-pwa/pwa-integration.service';

@Directive({
    selector: '[ifStandalone]'
})
export class IfStandaloneDirective extends NgIf implements OnInit {
    /**
     * Integration service
     */

    protected pwaIntegrationService = inject(PwaIntegrationService);

    ngOnInit() {
        this.ngIf = this.pwaIntegrationService.isStandalone;
    }
}
